// Modelo de datos para Sucursal
export class Sucursal {
  constructor(data = {}) {
    console.log('🔍 Sucursal constructor - data recibido:', data);
    console.log('🔍 Sucursal constructor - keys disponibles:', Object.keys(data));
    
    // Normalizar las claves de entrada
    const normalizedData = this.normalizeKeys(data);
    
    // Mapeo de campos básicos
    this.Id_sucursal = normalizedData.id_sucursal || normalizedData.Id_sucursal || 0;
    this.Id_Empresa = normalizedData.id_empresa || normalizedData.Id_empresa || 0;   
    this.Nombre_sucursal = normalizedData.nombre_sucursal || normalizedData.Nombre_sucursal || '';
    this.Direccion = normalizedData.direccion || normalizedData.Direccion || '';
    this.Telefono = normalizedData.telefono || normalizedData.Telefono || '';
    this.Email = normalizedData.email || normalizedData.Email || '';
    this.Estado = normalizedData.estado || normalizedData.Estado || 'ACTIVO';
    this.Responsable = normalizedData.responsable || normalizedData.Responsable || '';
    
    // Campos de imágenes (para mostrar)
    this.Logo = normalizedData.logo || normalizedData.Logo || '';
    this.Banner = normalizedData.banner || normalizedData.Banner || '';
    
    // Campos de archivos (para enviar)
    this.LogoFile = normalizedData.logoFile || normalizedData.LogoFile || null;
    this.BannerFile = normalizedData.bannerFile || normalizedData.BannerFile || null;
    
    console.log('🔍 Sucursal constructor - objeto creado:', {
      Id_sucursal: this.Id_sucursal,
      Id_empresa: this.Id_Empresa,      
      Nombre_sucursal: this.Nombre_sucursal,
      Logo: this.Logo ? 'presente' : 'vacío',
      Banner: this.Banner ? 'presente' : 'vacío',
      LogoFile: this.LogoFile ? 'presente' : 'vacío',
      BannerFile: this.BannerFile ? 'presente' : 'vacío'
    });
  }

  normalizeKeys(data) {
    if (!data) return {};
    
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key.toLowerCase()] = value;
      normalized[key] = value;
    }
    return normalized;
  }

  // Validaciones
  isValid() {
    return this.Nombre_sucursal.trim() !== '' && 
           this.Direccion.trim() !== '';
  }

  // Método para generar URL de imagen desde base64
  getImageUrl(imageField) {
    const image = imageField === 'logo' ? this.Logo : this.Banner;
    
    if (!image) return null;
    
    // Si ya es una URL completa
    if (image.startsWith('data:') || image.startsWith('http')) {
      return image;
    }
    
    // Si es base64, crear data URL
    return `data:image/jpeg;base64,${image}`;
  }

  // Método para establecer imagen desde archivo
  setImageFromFile(file, imageType) {
    return new Promise((resolve, reject) => {
      if (!file) {
        if (imageType === 'logo') {
          this.LogoFile = null;
          this.Logo = '';
        } else {
          this.BannerFile = null;
          this.Banner = '';
        }
        resolve();
        return;
      }

      // Validar que sea un archivo de imagen
      if (!file.type.startsWith('image/')) {
        reject(new Error('El archivo debe ser una imagen'));
        return;
      }

      // Validar tamaño (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        reject(new Error('La imagen no debe superar los 5MB'));
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const result = e.target.result;
          const base64 = result.split(',')[1];
          
          if (imageType === 'logo') {
            this.Logo = base64;
            this.LogoFile = file;
          } else {
            this.Banner = base64;
            this.BannerFile = file;
          }
          
          console.log(`✅ ${imageType} procesado correctamente:`, file.name, file.size, 'bytes');
          resolve(base64);
        } catch (error) {
          console.error('❌ Error procesando imagen:', error);
          reject(error);
        }
      };
      
      reader.onerror = (error) => {
        console.error('❌ Error leyendo archivo:', error);
        reject(new Error('Error al leer el archivo'));
      };
      
      reader.readAsDataURL(file);
    });
  }

  // Limpiar imagen
  clearImage(imageType) {
    if (imageType === 'logo') {
      this.Logo = '';
      this.LogoFile = null;
    } else {
      this.Banner = '';
      this.BannerFile = null;
    }
  }

  // Verificar si tiene imagen
  hasImage(imageType) {
    const image = imageType === 'logo' ? this.Logo : this.Banner;
    return !!(image && image.length > 0);
  }

  // Obtener datos básicos (sin imágenes)
  getBasicData() {
    return {
      id_sucursal: this.Id_sucursal,
      id_empresa: this.Id_Empresa,      
      nombre_sucursal: this.Nombre_sucursal,
      direccion: this.Direccion,
      telefono: this.Telefono,
      email: this.Email,
      estado: this.Estado,
      responsable: this.Responsable
    };
  }

  // Para debug
  toDebug() {
    return {
      'Frontend (mayúsculas)': {
        Id_sucursal: this.Id_sucursal,
        Id_empresa: this.Id_Empresa,      
        Nombre_sucursal: this.Nombre_sucursal,
        Logo: this.Logo ? `[${this.Logo.length} caracteres]` : 'Sin logo',
        Banner: this.Banner ? `[${this.Banner.length} caracteres]` : 'Sin banner',
        LogoFile: this.LogoFile ? 'Archivo presente' : 'Sin archivo',
        BannerFile: this.BannerFile ? 'Archivo presente' : 'Sin archivo'
      },
      'Is Valid': this.isValid()
    };
  }
}